import { IconButton } from "@chakra-ui/react";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import MuiIcon from "components/MuiIcon";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SettingsElementT } from "shared/api/types/services";
import CutText from "shared/components/CutText";
import Link from "shared/components/Link";
import useGetColors from "shared/hooks/useGetColors";
import { PathsE, PathsParams, SearchParams } from "shared/routes";

export const useGetGetBreadcrumbs = () => {
  const { t } = useTranslation();
  return [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
  ];
}

interface Params {
  serviceId: string,
  page?: string,
  size?: string
}


export const useGetColumns = ({ serviceId, page, size }: Params) => {
  const { blue500 } = useGetColors();
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<SettingsElementT>();

  return useMemo(
    () => [
      columnHelper.accessor('id', {
        header: t('services.table.id'),
        id: 'id',
        cell: ({ getValue }) => (
          <CutText fontWeight="700">
            {getValue()}
          </CutText>
        ),
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '90px',
              maxW: '90px',
            }
          }
        }
      }),
      columnHelper.accessor('value', {
        header: t('services.table.value'),
        id: 'value',
        meta: {
          styles: {
            sizes: {
              maxW: '300px',
            },
          },
        },
      }),
      columnHelper.accessor('description', {
        header: t('services.table.description'),
        id: 'description',
      }),
      // columnHelper.accessor('createdAt', {
      //   header: t('services.table.createdAt'),
      //   id: 'createdAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      // columnHelper.accessor('updatedAt', {
      //   header: t('services.table.updatedAt'),
      //   id: 'updatedAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      columnHelper.accessor('id', {
        header: '',
        id: 'actions',
        cell: ({ row }) => (
          <Link<PathsParams[PathsE.UPDATE_SETTING], SearchParams[PathsE.UPDATE_SETTING]>
            path={PathsE.UPDATE_SETTING}
            pathsParams={{ serviceId, settingId: row.original.id }}
            searchParams={{ page, size }}
          >
            <IconButton
              mr="2"
              aria-label="Edit"
              borderRadius="10px"
              backgroundColor="transparent"
              icon={<MuiIcon name="edit" color={blue500} />}
            />
          </Link>
        ),
        meta: {
          styles: {
            sizes: {
              width: '44px'
            }
          }
        }
      }),
    ] as ColumnDef<SettingsElementT>[],
    [t, page, size, serviceId]
  );
};
